import React from "react";

export default function LinkedActivityPanel({ activity, compact = false }) {
  if (!activity) return null;

  const items = [
    { key: "pendingBettings", label: "Pending bets", value: activity.pendingBettings ?? 0 },
    { key: "activeP2P", label: "Active P2P", value: activity.activeP2P ?? 0 },
    { key: "predictions", label: "Predictions", value: activity.predictions ?? 0 },
    { key: "openMarkets", label: "Open markets", value: activity.openMarkets ?? 0 },
  ];

  const total =
    activity.totalLinked ??
    items.reduce((sum, item) => sum + item.value, 0);

  return (
    <section className={`alg-linked-activity${compact ? " is-compact" : ""}`} aria-label="Linked activity">
      <div className="alg-linked-activity-head">
        <span className="alg-linked-activity-title">Linked activity</span>
        <span className={`alg-linked-activity-total${activity.hasLinkedActivity ? " has-activity" : ""}`}>
          {total} total
        </span>
      </div>
      <div className="alg-linked-activity-grid">
        {items.map((item) => (
          <div key={item.key} className="alg-linked-activity-stat">
            <span className="alg-linked-activity-val tabular-nums">{item.value}</span>
            <span className="alg-linked-activity-key">{item.label}</span>
          </div>
        ))}
      </div>
      {activity.hasLinkedActivity ? (
        <p className="alg-linked-activity-note">
          Disable is blocked while linked activity exists. Use force-disable only if you accept unsettled exposure.
        </p>
      ) : (
        <p className="alg-linked-activity-note is-muted">No linked bets, P2P, predictions, or open markets.</p>
      )}
    </section>
  );
}
